import { useMobileBoxLayout } from './BoxLayouts';
import { BoxLandscapeGift } from '../BoxLandscapeGift';
import type { ReactNode } from 'react';
import type { BoxInfo, CardInfo } from '@lub0v/santa-utils';
import { Shell, PageContent } from '@src/components';
import { ParticipantCounter } from '../ParticipantCounter';

export function BoxGameShell({
  info,
  cards,
  main,
  sceneOnly = false,
  headerTools,
  width,
  children,
}: {
  info: BoxInfo | null;
  cards: CardInfo[];
  main: boolean;
  sceneOnly?: boolean;
  headerTools?: ReactNode;
  width?: 'dialog';
  children: ReactNode;
}) {
  const mobile = useMobileBoxLayout();
  return (
    <Shell
      footer={!sceneOnly}
      headerTools={headerTools}
      transparentHeader
      landscape={main ? 'clear' : 'soft'}
      landscapeOverlay={!mobile && main && info ? <BoxLandscapeGift key={info.box.key + ":" + info.cardId} info={info} /> : undefined}
      landscapeForeground={
        main && info ? (
          <ParticipantCounter info={info} cards={cards} testId="desktop-participant-counter" />
        ) : undefined
      }
    >
      <PageContent pad="box" width={width} testId="box-page">
        {children}
      </PageContent>
    </Shell>
  );
}
